import { injectedStore } from '../../ConfigureStore';

export default function getXBrandID(): string {
  return injectedStore.getState().config.xBrandId;
}
